import React from "react";
import CarsSecondSideBar from "../secondSideBars/carsSecondSideBar";
import SideBarInner from "./../../../shared/sideBarInner";
import JobRequestListWrapper from "./../cars/JobRequestListWrapper.js";
import SideBar from "./../../sides/sideBar";
import styles from "./jobRequestsBar.module.scss";
import TitleBarWrapper from "../../../shared/titleBarWrapper";
import FirstTitle from "../../../shared/items/static/firstTitle";
import TitleClosedBarWrapper from "../../../shared/titleClosedBarWrapper";
import { withJobRequests } from "../../../shared/containers/containerJobRequests.js";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Radio } from "@mui/material";

const jobRequestType = {
  "-1": "Все типы",
  0: "Заявка",
  1: "Установка",
};

const JobRequestsBar = (props) => {
  const { jobRequestsFilter, onSetJobRequestsFilter, selectJobRequest } = props;

  return (
    <div className={styles.sideBarsWrapper}>
      <SideBar
        TitleClosed={
          <TitleClosedBarWrapper>
            <FirstTitle>{"Заявки"}</FirstTitle>
          </TitleClosedBarWrapper>
        }
      >
        <div className={styles.carsBar}>
          <SideBarInner>
            <TitleBarWrapper>
              <FirstTitle>{"Заявки"}</FirstTitle>
            </TitleBarWrapper>
          </SideBarInner>

          <SideBarInner>
            <div>
              <div className={styles.jobRequestsFilterWinterContainer}>
                <div>
                  <Radio
                    key={jobRequestsFilter.jobRequestType}
                    disabled={selectJobRequest !== null}
                    className={styles.MuiRadio_resolve}
                    checked={!jobRequestsFilter.isWinter}
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      jobRequestsFilter.isWinter = false;
                      onSetJobRequestsFilter(jobRequestsFilter);
                    }}
                  />
                  <b> Обычные</b>
                </div>

                <div>
                  <Radio
                    key={jobRequestsFilter.jobRequestType}
                    disabled={selectJobRequest !== null}
                    className={styles.MuiRadio_resolve}
                    checked={jobRequestsFilter.isWinter}
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      jobRequestsFilter.isWinter = true;
                      onSetJobRequestsFilter(jobRequestsFilter);
                    }}
                  />
                  <b> Зима</b>
                </div>
              </div>

              <div>
                <Select
                  key={jobRequestsFilter.jobRequestType}
                  disabled={selectJobRequest !== null}
                  style={{ width: "280px", height: "24px", margin: "0px", fontSize: "12px", display: "block!important" }}
                  onChange={(e) => {
                    e.stopPropagation();

                    jobRequestsFilter.jobRequestType = parseInt(e.target.value);
                    onSetJobRequestsFilter(jobRequestsFilter);
                  }}
                  defaultValue={jobRequestsFilter.jobRequestType}
                >
                  {Object.keys(jobRequestType).map((x) => {
                    return (
                      <MenuItem key={x} value={x} name={jobRequestType[x]} className={styles.MuiButtonBase_resolve}>
                        <div>{jobRequestType[x]}</div>
                      </MenuItem>
                    );
                  })}
                </Select>
              </div>
            </div>
          </SideBarInner>

          <SideBarInner>
            <div className={styles.container_carsList}>
              <JobRequestListWrapper />
            </div>
          </SideBarInner>
        </div>
      </SideBar>

      <CarsSecondSideBar />
    </div>
  );
};

export default withJobRequests(JobRequestsBar);
